import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import UserIcon from '@offerzen/zenicon/UserIcon'
import AccessibleIcon from '../AccessibleIcon'
import LazyImage from '../LazyImage'
import { getNameInitials } from '../../helpers/nameHelpers'
import styles, { wrapperSize, wrapperTheme, wrapperColor, imageRender, initialsTheme, initialsSize, iconTheme, iconSize } from './styles'

class Avatar extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    loaded: false,
    errored: false,
  }

  render() {
    const { loaded, errored } = this.state
    const { name, loader, url, padded, size, theme, themeModifier, backgroundColor, ...props } = this.props

    let content
    if (loader) {
      content = <LazyImage loader={loader} alt={name} />
    } else if (url && !errored) {
      content = (
        <img
          src={url}
          alt={name}
          className={imageRender(loaded)}
          onLoad={() => this.setState({ loaded: true, errored: false })}
          onError={() => this.setState({ loaded: true, errored: true })}
        />
      )
    } else if (props.fallback === 'initials' && name) {
      content = <span className={cx(styles.fallbackInitials, initialsTheme(theme), initialsSize(size))}>{getNameInitials(name)}</span>
    } else {
      content = (
        <AccessibleIcon
          icon={UserIcon}
          color={iconTheme(theme, themeModifier)}
          className={cx(styles.fallbackIcon, !padded && iconSize(size))}
        />
      )
    }

    return (
      <figure
        className={cx(
          styles.wrapper,
          wrapperSize(size, padded),
          wrapperTheme(theme, themeModifier),
          loaded && !errored && wrapperColor(backgroundColor),
          props.round && styles.rounded,
          padded && styles.padded,
          props.className,
        )}>
        {content}
      </figure>
    )
  }
}

Avatar.propTypes = {
  url: PropTypes.string,
  backgroundColor: PropTypes.string,
  loader: PropTypes.func,
  name: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  themeModifier: PropTypes.oneOf(['', 'light', 'dark']),
  size: PropTypes.oneOf(['', 'default', 'extraSmall', 'small', 'medium', 'large', 'extraLarge', 'extraExtraLarge']),
  fallback: PropTypes.oneOf(['', 'icon', 'initials']),
  round: PropTypes.bool,
  padded: PropTypes.bool,
  className: PropTypes.string,
}

Avatar.defaultProps = {
  theme: 'primary',
  themeModifier: 'light',
  size: 'default',
  fallback: 'icon',
}

export default Avatar
